import axios from "axios";

export const getDadosSirLojaOnline = (data) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/motor/get-dados-sir`, { params: data })
    .then((response) => response.data)
    .catch((e) => {
      console.error(e);
      return e?.response?.data || e;
    });
};

export const getReservaStatusOptions = () => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/motor/sor-motor-status`)
    .then((response) => response.data)
    .catch((e) => Promise.resolve(e));
};

export const getEscalaCobrancaPromotor = () => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/motor/sor-escala-cobranca-promotor`)
    .then((response) => response.data)
    .catch((e) => Promise.resolve(e));
};

export const storeMotor = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/motor`, data)
    .then((response) => response.data)
    .catch((e) => Promise.resolve(e));
};